import { render, staticRenderFns } from "./orderOverview.vue?vue&type=template&id=62b07ccd&"
import script from "./orderOverview.vue?vue&type=script&lang=js&"
export * from "./orderOverview.vue?vue&type=script&lang=js&"
import style0 from "./orderOverview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports